<template>
  <input type="hidden" name="_token" :value="$csrfToken">
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
    };
  },
};
</script>
